import { Box3, type Object3D } from "three";
import type { DxfMirrorAxes } from "../cad/dxf-insert-transform";

type DxfMirrorState = DxfMirrorAxes & {
  basePositionY: number;
};

const mirrorStates = new WeakMap<Object3D, DxfMirrorState>();

export function applyDxfMirror(object: Object3D, axes: DxfMirrorAxes) {
  const existing = mirrorStates.get(object);
  const state = {
    ...axes,
    basePositionY: existing?.basePositionY ?? object.position.y
  };
  mirrorStates.set(object, state);
  alignMirroredObject(object, state);
}

export function refreshDxfMirror(object: Object3D) {
  const state = mirrorStates.get(object);
  if (state) {
    alignMirroredObject(object, state);
  }
}

function alignMirroredObject(object: Object3D, state: DxfMirrorState) {
  object.position.y = state.basePositionY;
  object.scale.set(1, 1, 1);
  object.updateWorldMatrix(true, true);
  const baselineBounds = new Box3().setFromObject(object);

  object.scale.set(state.mirrorX ? -1 : 1, state.mirrorY ? -1 : 1, state.mirrorZ ? -1 : 1);
  object.updateWorldMatrix(true, true);
  if (!state.mirrorY || baselineBounds.isEmpty()) {
    return;
  }

  const mirroredBounds = new Box3().setFromObject(object);
  if (!mirroredBounds.isEmpty()) {
    object.position.y += baselineBounds.min.y - mirroredBounds.min.y;
    object.updateWorldMatrix(true, true);
  }
}
